interface ITranslations {
    [language: string] : {
        translation: {
            title: string,
            subtitle: string,
            footer: string,
            footer2: string,
            valueReceived: string,
            windDirection: string,
            windSpeed: string,
            windGust: string,
            airTemperature: string,
            relativeHumidity: string,
            windChill: string,
            heatStress: string,
            airPressure: string,
            waterLevel: string,
            waterDepth: string,
            waterTemperature: string,
            disclaimer: string,
            disclaimerTitle: string,
        }
    }
}

export const translations: ITranslations = {
    kk: {
        translation: {
            title: "Шығыс Қашағандағы ауа райы және су деңгейі",
            subtitle: "Нақты уақыт режимі. Алынған мәндер:",
            valueReceived: "Алынған мән",
            windDirection: "Желдің бағыты, °",
            windSpeed: "Желдің жылдамдығы, м/с",
            windGust: "Желдің ұйытқуы, м/с",
            airTemperature: "Ауа температурасы, °C",
            relativeHumidity: "Салыстырмалы ылғалдылығы, %",
            windChill: "Сезілетін температурасы, °C",
            heatStress: "Жылу стрессі, °C",
            airPressure: "Атмосфералық қысымы QNH (теңіз деңгейіне келтірілген), мбар",
            waterLevel: "Су деңгейі, мКЖ*",
            waterTemperature: "Су температурасы, °C",
            footer: "*Каспий Биіктік Жүйесінің метрлері",
            footer2: "**3.2 мКЖ батиметриялық анықтамалық тереңдігінен есептелген",
            waterDepth: "Су тереңдегі Шығыс Қашағандағы, м**",
            disclaimer: "Бұл панельдегі деректер тек ақпараттық мақсатта ұсынылған. Компания осы панельдегі кез келген деректерді пайдалануға байланысты кез келген тұлғаға келтіретін қателер және/немесе зақымдар үшін жауапкершілік алмайды. Барлық деректер ешқандай кепілдіксіз «сол күйінде» беріледі.",
            disclaimerTitle: "Жауапкершіліктен бас тарту",
        }
    },
    ru: {
        translation: {
            title: "Погода и уровень воды на Восточном Кашагане",
            subtitle: "Режим реального времени. Полученные значения:",
            valueReceived: "Значение получено в",
            windDirection: "Направление ветра, °",
            windSpeed: "Скорость ветра, м/с",
            windGust: "Порывы ветра, м/с",
            airTemperature: "Температура воздуха, °C",
            relativeHumidity: "Относительная влажность, %",
            windChill: "Ощущаемая температура, °C",
            heatStress: "Тепловой стресс, °C",
            airPressure: "Атмосферное давление (QNH приведенное к уровню моря), мбар",
            waterLevel: "Уровень воды, мКС*",
            waterTemperature: "Температура воды, °C",
            footer: "*метры Каспийской Системы Высот",
            footer2: "**Рассчитано от батиметрической эталонной глубины 3.2 мКС",
            waterDepth: "Глубина воды на Восточном Кашагане, м**",
            disclaimer: "Данные, представленные на данной панели мониторинга, предназначены только для информационных целей. Компания не несет никакой ответственности за любые ошибки и/или ущерб, который может быть понесен любым лицом в связи с использованием любых данных на панели мониторинга. Все данные предоставляются «как есть», без каких-либо гарантий.",
            disclaimerTitle: "Отказ от ответственности",
        }
    },
    en: {
        translation: {
            title: "Kashagan East weather and water level",
            subtitle: "Real-time mode. Values received:",
            valueReceived: "Value received at",
            windDirection: "Wind Direction, °",
            windSpeed: "Wind Speed, m/s",
            windGust: "Wind Gust, m/s",
            airTemperature: "Air Temperature, °C",
            relativeHumidity: "Relative Humidity, %",
            windChill: "Wind Chill, °C",
            heatStress: "Heat Stress, °C",
            airPressure: "Air Pressure QNH, mBar",
            waterLevel: "Water Level, mCD*",
            waterTemperature: "Water Temperature, °C",
            footer: "*meters Caspian Datum",
            footer2: "**Calculated from bathymetric reference depth of 3.2 mCD",
            waterDepth: "Water depth at Kashagan East, m**",
            disclaimer: "The data presented on this dashboard is for informational purposes only. The Company assumes no liability for any errors and/or any loss that may be suffered by any person in connection with the use of any of the data on the dashboard. All data is provided 'as is,' with no guarantees of any kind of accuracy.",
            disclaimerTitle: "Disclaimer",
        }
    },
}